import { Component, Input } from '@angular/core';
import { data } from 'src/app/data';
import { CartService } from 'src/app/shared/services/cart.service';
import { RootService } from 'src/app/shared/services/root.service';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { DropcartType } from './components/dropcart/dropcart.component';
import { ActivatedRoute } from '@angular/router';
import { OffcanvasCartService } from 'src/app/shared/services/offcanvas-cart.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    data = data;
    @Input() layout: 'classic'|'compact' = 'classic';
    dropcartType: DropcartType;

    constructor(
        public wishlist: WishlistService,
        public root: RootService,
        public cart: CartService,
        private route: ActivatedRoute,
        private offcanvasCart: OffcanvasCartService,


    ) { }
    ngOnInit() {
        this.route.data.subscribe(data => {
            this.dropcartType = data.dropcartType || 'dropdown';
        });
    }
    onCartClick(): void {
        if (this.dropcartType === 'offcanvas') {
            this.offcanvasCart.open();
        }
    }
}
